export const AnchorFeature: React.FC<Umbraco.Anchor> = ({ content }) => <div id={content?.properties?.anchorName}></div>;
